/**
 * Serviceplan MAKEOS
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface UpdateSystemPreferenceDto { 
    brandingKey?: string;
    dashboardCollection?: Array<string>;
    dashboardKeywords?: Array<string>;
}

